__turbopack_context__.v({
  "countBadge": "CPhotoGallery-module__Lpo7Bq__countBadge",
  "cover": "CPhotoGallery-module__Lpo7Bq__cover",
  "coverPlaceholder": "CPhotoGallery-module__Lpo7Bq__coverPlaceholder",
  "coverWrap": "CPhotoGallery-module__Lpo7Bq__coverWrap",
  "empty": "CPhotoGallery-module__Lpo7Bq__empty",
  "galleries": "CPhotoGallery-module__Lpo7Bq__galleries",
  "galleryBack": "CPhotoGallery-module__Lpo7Bq__galleryBack",
  "galleryBackLink": "CPhotoGallery-module__Lpo7Bq__galleryBackLink",
  "galleryCard": "CPhotoGallery-module__Lpo7Bq__galleryCard",
  "galleryCardBody": "CPhotoGallery-module__Lpo7Bq__galleryCardBody",
  "galleryCardLink": "CPhotoGallery-module__Lpo7Bq__galleryCardLink",
  "galleryDesc": "CPhotoGallery-module__Lpo7Bq__galleryDesc",
  "galleryLead": "CPhotoGallery-module__Lpo7Bq__galleryLead",
  "galleryName": "CPhotoGallery-module__Lpo7Bq__galleryName",
  "pagination": "CPhotoGallery-module__Lpo7Bq__pagination",
  "paginationHint": "CPhotoGallery-module__Lpo7Bq__paginationHint",
  "paginationInfo": "CPhotoGallery-module__Lpo7Bq__paginationInfo",
  "photoCaption": "CPhotoGallery-module__Lpo7Bq__photoCaption",
  "photoItem": "CPhotoGallery-module__Lpo7Bq__photoItem",
  "photos": "CPhotoGallery-module__Lpo7Bq__photos",
  "root": "CPhotoGallery-module__Lpo7Bq__root",
});
